import { Tab, Menu, Transition } from "@headlessui/react";
import React, { Fragment, useEffect, useState, useRef } from "react";
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/24/outline";
import { classNames, formatDateToDD_MMM_YYYY } from "../../../../helpers/functions";
import { ReactSVG } from "react-svg";
import NewToolTip from "../../../common/New-ToolTip";
import MedicationCreate from "../service-steps/clinical-assessment/MedicationCreate";
import AddMedicationDialog from "./AddMedicationDialog";
import MedicationsHeader from "./sidebar/MedicationsHeader";
import StandardMedicationView from "./sidebar/StandardMedicationView";
import AMRPreReviewView from "./sidebar/AMRPreReviewView";
import AMRPostReviewView from "./sidebar/AMRPostReviewView";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  updateMedication,
  updateMedicationReview,
} from "../../../../redux/modules/clinical-services/actions";
import {
  setDrugStatus,
  setSelectedMedicationId,
  setSortBy,
  setExpandedSection,
  setPrescribedRxEnabled,
} from "../../../../redux/modules/medications/actions";
import PreReview from "../../../common/tooltip/medication-review/pre-review";
import PostReview from "../../../common/tooltip/medication-review/post-review";
import InfoTool from "../../../common/InfoTool";
import DiscontinueDialog from "./DiscontinueDialog";
import { AdherenceTypes } from "../service-steps/medication/data";
import { drugTypes } from "../service-steps/clinical-assessment/data";
import { createPortal } from "react-dom";
import { ClinicalServiceTypes } from "../../text/data";
import { getTreatmentDrugs } from "../service-steps/treatment/data";
import { medicationMatchesAmrEducation } from "../../../../helpers/amrEducationDrugMatch";

const Medications = ({
  selectMedication = (val) => {},
  checkLastMedication = (val) => {},
  reviewedMedicationCards = [],
  selectedMedication = null,
  isAMR = false,
  isAdditional = false,
  showMedication = false,
  showHighlightedAMRDrugs = false,
  isIntervention = false,
  defaultExpandedSection = null,
  activeTab = null,
  /** Education drug table: highlight all sidebar rows that match Redux amrEducation (multiple OK). */
  highlightAmrEducationMatches = false,
  medicationCreateRequest = null,
}) => {
  const { medications, clinicalServiceObj, amrEducation, clinicalServiceName } =
    useSelector((state) => state.clinicalService);
  const { patient } = useSelector((state) => state.patients);
  const {
    drugStatus,
    selectedMedicationId,
    sortBy,
    expandedSection,
    prescribedRxEnabled,
  } = useSelector((state) => state.medications);
  const dispatch = useDispatch();

  const [showMeds, setShowMeds] = useState(showMedication);
  const [filteredMedication, setFilteredMedication] = useState([]);
  const [selectedMedsForAccordion, setSelectedMedsForAccordion] = useState([]);
  const { id: patientId, serviceId } = useParams();
  const [showMedicationSlider, setShowMedicationSlider] = useState(false);
  const [showAddMedicationDialog, setShowAddMedicationDialog] = useState(false);
  const [latestMedicationData, setLatestMedicationData] = useState(null);
  const [medicationFormKey, setMedicationFormKey] = useState(0);
  const [isPreReview, setIsPreReview] = useState(true);
  const [focusItem, setFocusItem] = useState(null);
  const [hoveredMed, setHoveredMed] = useState(null);
  const [openDiscontiuePopup, setOpenDiscontiuePopup] = useState(false);
  const [discontinueDrug, setDiscontinueDrug] = useState(null);
  const [isReviewedDrug, setIsReviewedDrug] = useState(null);
  const [currentSubStep, setCurrentSubStep] = useState(null);
  const [currentStep, setCurrentStep] = useState(null);
  const [showMenu, setShowMenu] = useState(false);
  const [menuMedication, setMenuMedication] = useState(null);
  const [menuData, setMenuData] = useState({ top: 0, left: 0 });
  const [showInterectionTooltip, setShowInterectionTooltip] = useState(false);
  const [expandedDiscontinued, setExpandedDiscontinued] = useState([]);
  const hasInitializedExpandedSection = useRef(false);
  const previousDefaultExpandedSection = useRef(defaultExpandedSection);
  const previousTabName = useRef(activeTab?.name);

  useEffect(() => {
    setShowMeds(showMedication);
  }, [showMedication]);

  useEffect(() => {
    const selectedDrugName = medicationCreateRequest?.drugName?.toString().trim();
    if (!selectedDrugName) return;

    const prefilledMedication = {
      label: selectedDrugName,
      value: selectedDrugName,
      displayText: selectedDrugName,
      identifier: selectedDrugName,
      type: "Sentence",
    };

    setClickedMedication(prefilledMedication);
    setLatestMedicationData(null);
    setMedicationFormKey((prev) => prev + 1);
    setShowMeds(true);
    setShowMedicationSlider(true);
  }, [medicationCreateRequest]);

  // Open MedicationCreate when latestMedicationData is available
  useEffect(() => {
    if (latestMedicationData && !showMedicationSlider) {
      setShowMedicationSlider(true);
    }
  }, [latestMedicationData, showMedicationSlider]);

  // AddMedicationDialog handlers
  const handleAddMedicationDialogSave = (data) => {
    setLatestMedicationData(data);
    setShowAddMedicationDialog(false);
  };

  const handleAddMedicationDialogClose = () => {
    setShowAddMedicationDialog(false);
  };

  useEffect(() => {
    if (
      clinicalServiceObj &&
      clinicalServiceObj.initialAssessment.initialAssessmentForm
    ) {
      let obj = clinicalServiceObj.initialAssessment.initialAssessmentForm;
      setCurrentSubStep(obj.currentSubStep);
      setCurrentStep(obj.currentStep);
    }
  }, [clinicalServiceObj]);

  //Dhruv State for integration
  const [clickedMedication, setClickedMedication] = useState(null);

  const expandMedicine = (id) => {
    if (selectedMedsForAccordion.includes(id)) {
      setSelectedMedsForAccordion(
        selectedMedsForAccordion.filter((item) => item !== id)
      );
    } else {
      setSelectedMedsForAccordion([...selectedMedsForAccordion, id]);
    }
  };

  const toggleDiscontinuedExpansion = (id) => {
    if (expandedDiscontinued.includes(id)) {
      setExpandedDiscontinued(
        expandedDiscontinued.filter((item) => item !== id)
      );
    } else {
      setExpandedDiscontinued([...expandedDiscontinued, id]);
    }
  };

  const sortMedications = (meds) => {
    if (sortBy == "alphabetic") {
      setFilteredMedication(
        [...meds].sort((a, b) => a.displayName.localeCompare(b.displayName))
      );
    } else if (sortBy == "newest") {
      setFilteredMedication(
        [...meds].sort((a, b) => new Date(b.created) - new Date(a.created))
      );
    } else if (sortBy == "oldest") {
      setFilteredMedication(
        [...meds].sort((a, b) => new Date(a.created) - new Date(b.created))
      );
    }
  };

  const filterMedications = () => {
    let meds = medications.filter(
      (x) => drugStatus === "all" || x.status === drugStatus
    );
    setFilteredMedication(meds);
    sortMedications(meds);
  };

  useEffect(() => {
    filterMedications();
  }, [medications, drugStatus, sortBy]);

  useEffect(() => {
    if (medications?.length > 0) {
      let remainingMeds = medications?.filter(
        (x) =>
          (isAdditional
            ? x.medicationType === drugTypes.Additional
            : x.medicationType === drugTypes.Prescription) &&
          x.status === "active" &&
          !reviewedMedicationCards.some((r) => r.name === x.displayName)
      );
      checkLastMedication(remainingMeds.length === 0);
    }
  }, [reviewedMedicationCards, medications]);

  const updateMedicationStatus = (med, status, discontinueData = null) => {
    if (isReviewedDrug && status === "inactive") removeReviewedCard(med);

    const updatedMedicationObject = {
      ...med,
      status: status,
      // mark discontinuedDuringReview when discontinuing inside AMR flow
      ...(isAMR && status === "inactive" ? { discontinuedDuringReview: true } : {}),
      ...(discontinueData && {
        inactiveDate: discontinueData.inactiveDate,
        inactiveWhen: discontinueData.whenDiscontinued,
        inactiveInitiator: discontinueData.source,
        inactiveCommunicationType: discontinueData.communicationType,
        inactiveReason: discontinueData.reason,
        inactiveOtherReason: discontinueData.otherReason,
      }),
    };
    let medication = {
      medications: [updatedMedicationObject],
    };
    dispatch(updateMedication(patientId, medication));
    setMenuMedication(null);
  };

  const updateMedicationType = (med, medicationType) => {
    const updatedMedicationObject = {
      ...med,
      medicationType,
    };
    const medication = {
      medications: [updatedMedicationObject],
    };
    dispatch(updateMedication(patientId, medication));
    setMenuMedication(null);
    setShowMenu(false);
  };

  const removeReviewedCard = (med) => {
    let obj =
      clinicalServiceObj.initialAssessment.initialAssessmentForm.medications;
    if (
      clinicalServiceObj.initialAssessment.initialAssessmentForm !==
        undefined &&
      obj !== null &&
      obj !== undefined &&
      obj?.medications?.length > 0
    ) {
      let updatedReviewCards = obj.medications.filter(
        (card) => card.medicationId !== med.id
      );
      const updatedClinicalServiceObj = {
        medications: { medications: updatedReviewCards },
        currentStep: currentStep,
        currentSubStep: currentSubStep,
      };
      dispatch(updateMedicationReview(serviceId, updatedClinicalServiceObj));
    }
  };

  const isMatchingDrug = (med) => {
    if (!highlightAmrEducationMatches) return false;
    return medicationMatchesAmrEducation(amrEducation, med);
  };

  const getCardFromDrug = (drug) => {
    return reviewedMedicationCards.find((x) => x.name === drug.displayName);
  };

  const getDrugFromCard = (card) => {
    return medications.find((x) => x.displayName === card.name);
  };

  const medicationDetails = (medication) => {
    const prescribedDate = medication?.created || medication?.startDate;
    return (
      <div className="p-3">
        <div className="px-4 gap-2 font-normal text-xs flex flex-col">
          <div className="flex flex-row justify-between items-center">
            <span>Date Prescribed</span>
            <span>{prescribedDate ? formatDateToDD_MMM_YYYY(prescribedDate) : ''}</span>
          </div>
          <div
            className={`flex flex-row justify-between items-center border-b-[1px] border-b-gray-100`}
          >
            {/* <span>Recent Rx #: XXXXXXXX</span>
            <span>12-Jun-2024</span> */}
          </div>
          <div className="flex flex-row items-center justify-between">
            <span>DIN: 01234567 </span>
            {/* <span className="font-semibold text-REELTeal">Unfilled</span> */}
          </div>
          <div className="flex flex-row items-center justify-between">
            <span>First Fill: 5-Apr-2000</span>
            <span>QTY: 100 </span>
          </div>
          <div className="flex flex-row items-center justify-between">
            <span>Last Fill: 17-Nov-2020</span>
            <span>Refill: 10</span>
          </div>
        </div>
      </div>
    );
  };

  // Handler functions for MedicationSidebarList component
  const handleMedicationListMenuOpen = (event, med) => {
    const rect = event.currentTarget.getBoundingClientRect();
    setMenuData({
      top: rect.top,
      left: rect.right + 10,
    });
    setShowMenu(true);
    setMenuMedication(med);
  };

  const handleMedicationListMenuAction = (action, med) => {
    switch (action) {
      case "close":
        setMenuMedication(null);
        setShowMenu(false);
        break;
      case "discontinue":
        setOpenDiscontiuePopup(true);
        setDiscontinueDrug(med);
        if (isAMR && getCardFromDrug(med)?.status !== "blank")
          setIsReviewedDrug(true);
        break;
      case "modify":
        setClickedMedication(med);
        setShowMedicationSlider(true);
        break;
      case "resume":
        updateMedicationStatus(med, "active");
        break;
      case "move-to-prescription":
        updateMedicationType(med, drugTypes.Prescription);
        dispatch(setExpandedSection("prescription"));
        break;
      case "move-to-additional":
        updateMedicationType(med, drugTypes.Additional);
        dispatch(setExpandedSection("additional"));
        break;
      case "move-to-vaccines":
        updateMedicationType(med, drugTypes.Vaccines);
        dispatch(setExpandedSection("prescription"));
        break;
      default:
        break;
    }
  };

  const handleMedicationListMedicationClick = (med) => {
    const isAlreadySelected = String(selectedMedicationId) === String(med.id);
    const nextSelectedId = isAlreadySelected ? null : med.id;

    // Toggle local focus + Redux selection so second click deselects.
    setFocusItem(nextSelectedId);
    dispatch(setSelectedMedicationId(nextSelectedId));

    // If deselecting the same row, do not force section switching.
    if (isAlreadySelected) return;

    // Update expanded section based on medication type
    if (
      med.medicationType === drugTypes.PrescribedRx ||
      med.medicationType === drugTypes.HistoryPrescribedRx
    ) {
      dispatch(setExpandedSection("prescribedRx"));
    } else if (med.medicationType === drugTypes.Prescription) {
      dispatch(setExpandedSection("prescription"));
    } else if (med.medicationType === drugTypes.Additional) {
      dispatch(setExpandedSection("additional"));
    }
  };

  const handleMedicationListExpandMedication = (medId) => {
    expandMedicine(medId);
  };

  const getMenuContent = () => {
    return createPortal(
      <div
        className="fixed inset-0 z-50"
        onClick={() => {
          setMenuMedication(null);
          setShowMenu(false);
        }}
      >
        <div
          className="flex flex-col fixed bg-white shadow-lg border border-gray-200 rounded-[4px] w-50 z-50"
          style={{
            left: `${menuData.left}px`,
            top: `${menuData.top}px`,
          }}
          onClick={(e) => e.stopPropagation()}
        >
          <button
            className={`${menuMedication?.status === "inactive" &&
              "opacity-40 pointer-events-none text-gray-200"
              } flex w-full text-left text-sm font-normal text-gray-800 pl-[14px] pr-7 py-[5px] border-b-gray-50 hover:bg-gray-50`}
            onClick={() => {
              setOpenDiscontiuePopup(true);
              setDiscontinueDrug(menuMedication);
              if (isAMR && getCardFromDrug(menuMedication)?.status !== "blank")
                setIsReviewedDrug(true);
              setMenuMedication(null);
              setShowMenu(false);
            }}
          >
            Discontinue
          </button>
          <button 
            disabled={true} 
            className="opacity-40 pointer-events-none flex w-full text-left text-sm font-normal text-gray-800 px-[14px] py-[5px] border-b-gray-50 hover:bg-gray-50"
          >
            History
          </button>
          <button
            className="opacity-40 flex w-full text-left text-sm font-normal text-gray-800 px-[14px] py-[5px] border-b-gray-50 hover:bg-gray-50"
            disabled={true}
          >
            Hold
          </button>
          <button
            className="flex w-full text-left text-sm font-normal text-gray-800 px-[14px] py-[5px] border-b-gray-50 hover:bg-gray-50"
            onClick={() => {
              setClickedMedication(menuMedication);
              setShowMedicationSlider(true);
              setMenuMedication(null);
              setShowMenu(false);
            }}
          >
            Modify
          </button>
          <button
            className={`${
              menuMedication?.medicationType === drugTypes.Prescription
                ? "opacity-40 pointer-events-none"
                : ""
            } flex w-full text-left text-sm font-normal text-gray-800 px-[14px] py-[5px] border-b-gray-50 hover:bg-gray-50`}
            onClick={() => {
              updateMedicationType(menuMedication, drugTypes.Prescription);
              dispatch(setExpandedSection("prescription"));
            }}
          >
            Move to Prescriptions
          </button>
          <button
            className={`${
              menuMedication?.medicationType === drugTypes.Additional
                ? "opacity-40 pointer-events-none"
                : ""
            } flex w-full text-left text-sm font-normal text-gray-800 px-[14px] py-[5px] border-b-gray-50 hover:bg-gray-50`}
            onClick={() => {
              updateMedicationType(menuMedication, drugTypes.Additional);
              dispatch(setExpandedSection("additional"));
            }}
          >
            Move to Additional Medications
          </button>
          <button
            className={`${
              menuMedication?.medicationType === drugTypes.Vaccines
                ? "opacity-40 pointer-events-none"
                : ""
            } flex w-full text-left text-sm font-normal text-gray-800 px-[14px] py-[5px] border-b-gray-50 hover:bg-gray-50`}
            onClick={() => {
              updateMedicationType(menuMedication, drugTypes.Vaccines);
              dispatch(setExpandedSection("prescription"));
            }}
          >
            Move to Vaccines
          </button>
          <button
            disabled={menuMedication?.status === "active"}
            className={` ${menuMedication?.status === "active" &&
              "opacity-40 pointer-events-none"
              } flex w-full text-left text-sm font-normal text-gray-800 px-[14px] py-[5px] border-b-gray-50 hover:bg-gray-50`}
            onClick={() => {
              updateMedicationStatus(menuMedication, "active");
              setMenuMedication(null);
              setShowMenu(false);
            }}
          >
            Resume
          </button>
          <button
            disabled={menuMedication?.status === "active"}
            className={` ${menuMedication?.status === "active" &&
              "opacity-40 pointer-events-none"
              } flex w-full text-left text-sm font-normal text-gray-800 px-[14px] py-[5px] border-b-gray-50 hover:bg-gray-50`}
            onClick={() => {
              // Void functionality
              setMenuMedication(null);
              setShowMenu(false);
            }}
          >
            Void
          </button>
        </div>
      </div>,
      document.body
    );
  };

  const getFilterMenu = () => {
    return (
      <Menu as="div" className="relative inline-block text-left pt-[6px]">
        <div className="flex items-center">
          <Menu.Button>
            <ReactSVG src="/icons/filter_list.svg" className="pl-2 " />{" "}
          </Menu.Button>
        </div>
        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform translate-y-2 opacity-0 scale-95"
          enterTo="transform translate-y-0 opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform translate-y-0 opacity-100 scale-100"
          leaveTo="transform translate-y-2 opacity-0 scale-95"
        >
          <Menu.Items className="min-w-[200px] absolute z-[100] left-0 w-40 origin-top-left bg-white divide-y divide-gray-20 rounded-md shadow-lg ring-opacity-5">
            <Menu.Item>
              <button
                className={`block w-full text-left px-3 py-3 border-b border-b-gray-20 
            ${drugStatus === "all" && "bg-blue-100"} hover:bg-gray-50`}
                onClick={(e) => {
                  dispatch(setDrugStatus("all"));
                }}
              >
                All
              </button>
            </Menu.Item>
            <Menu.Item>
              <button
                className={`block w-full text-left px-3 py-3 border-b border-b-gray-20 
            ${drugStatus === "active" && "bg-blue-100"} hover:bg-gray-50`}
                onClick={(e) => {
                  dispatch(setDrugStatus("active"));
                }}
              >
                Active
              </button>
            </Menu.Item>
            <Menu.Item>
              <button
                className={`block w-full text-left px-3 py-3 border-b border-b-gray-20 
            ${drugStatus === "inactive" && "bg-blue-100"} hover:bg-gray-50`}
                onClick={(e) => {
                  dispatch(setDrugStatus("inactive"));
                }}
              >
                Inactive
              </button>
            </Menu.Item>
            <Menu.Item className="relative">
              <Menu
                as="div"
                className={`block w-full px-3 py-3 border-b border-b-gray-20 hover:bg-gray-50`}
              >
                <div>
                  <Menu.Button className="w-full flex flex-row items-center justify-between text-left">
                    <span>Category Type</span>
                    <ChevronRightIcon className="w-4 h-4" />
                  </Menu.Button>
                </div>
                <Transition
                  as={Fragment}
                  enter="transition ease-out duration-100"
                  enterFrom="transform translate-y-2 opacity-0 scale-95"
                  enterTo="transform translate-y-0 opacity-100 scale-100"
                  leave="transition ease-in duration-75"
                  leaveFrom="transform translate-y-0 opacity-100 scale-100"
                  leaveTo="transform translate-y-2 opacity-0 scale-95"
                >
                  <Menu.Items className="min-w-fit absolute top-0 right-0 translate-x-full bg-white divide-gray-20 rounded-md shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none z-[100]">
                    <Menu.Item className="w-[280px]">
                      <button
                        className={`block text-left px-3 py-3 border-b border-b-gray-20 
                    ${prescribedRxEnabled && "bg-blue-100"} hover:bg-gray-50`}
                        onClick={(e) => {
                          const isCurrentlyEnabled = prescribedRxEnabled;
                          const isOutsideAllergicRhinitis =
                            clinicalServiceName !==
                            ClinicalServiceTypes.AllergicRhinitis;

                          if (isCurrentlyEnabled) {
                            // Toggle off: disable prescribedRx
                            dispatch(setPrescribedRxEnabled(false));
                            if (isOutsideAllergicRhinitis) {
                              // Hide prescribedRx section and expand prescription section
                              dispatch(setExpandedSection("prescription"));
                            }
                          } else {
                            // Toggle on: enable prescribedRx
                            dispatch(setPrescribedRxEnabled(true));
                            if (isOutsideAllergicRhinitis) {
                              // Show prescribedRx section and expand it
                              dispatch(setExpandedSection("prescribedRx"));
                            }
                          }
                        }}
                      >
                        Prescribed - Pending Dispense
                      </button>
                    </Menu.Item>
                  </Menu.Items>
                </Transition>
              </Menu>
            </Menu.Item>
            <Menu.Item className="relative">
              <Menu
                as="div"
                className="block w-full px-3 py-3 border-b border-b-gray-20 hover:bg-gray-50"
              >
                <div>
                  <Menu.Button className="w-full flex flex-row items-center justify-between text-left">
                    <span>Sort Order</span>
                    <ChevronRightIcon className="w-4 h-4" />
                  </Menu.Button>
                </div>
                <Transition
                  as={Fragment}
                  enter="transition ease-out duration-100"
                  enterFrom="transform translate-y-2 opacity-0 scale-95"
                  enterTo="transform translate-y-0 opacity-100 scale-100"
                  leave="transition ease-in duration-75"
                  leaveFrom="transform translate-y-0 opacity-100 scale-100"
                  leaveTo="transform translate-y-2 opacity-0 scale-95"
                >
                  <Menu.Items className="min-w-fit absolute top-0 left-16 translate-x-full bg-white divide-gray-20 rounded-md shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none z-[100]">
                    <Menu.Item>
                      <span
                        className={`block w-full text-left px-3 py-3 border-b border-b-gray-20 
                    ${
                      sortBy === "alphabetic" && "bg-blue-100"
                    } hover:bg-gray-50`}
                        onClick={(e) => {
                          dispatch(setSortBy("alphabetic"));
                        }}
                      >
                        Alphabetical
                      </span>
                    </Menu.Item>
                    <Menu.Item>
                      <button
                        className={`block w-full text-left px-3 py-3 border-b border-b-gray-20 
                    ${sortBy === "newest" && "bg-blue-100"} hover:bg-gray-50`}
                        onClick={(e) => {
                          dispatch(setSortBy("newest"));
                        }}
                      >
                        Newest on top
                      </button>
                    </Menu.Item>
                    <Menu.Item>
                      <button
                        className={`block w-full text-left px-3 py-3 border-b border-b-gray-20 
                    ${sortBy === "oldest" && "bg-blue-100"} hover:bg-gray-50`}
                        onClick={(e) => {
                          dispatch(setSortBy("oldest"));
                        }}
                      >
                        Oldest on top
                      </button>
                    </Menu.Item>
                    <Menu.Item>
                      <button
                        className="opacity-40 block w-full text-left px-3 py-3 border-b border-b-gray-20 hover:bg-gray-50"
                        disabled={true}
                      >
                        Custom range
                      </button>
                    </Menu.Item>
                  </Menu.Items>
                </Transition>
              </Menu>
            </Menu.Item>
          </Menu.Items>
        </Transition>
      </Menu>
    );
  };

  const getNoRecordMessage = (drugType) => {
    return (
      filteredMedication.filter((x) => x.medicationType === drugType).length ===
        0 && (
        <ul className="divide-y text-sm font-normal divide-gray-100 border-b border-b-gray-100">
          <li className="pl-7">
            <div className={`flex items-center justify-start h-[36px]`}>
              <span>No Records Found</span>
            </div>
          </li>
        </ul>
      )
    );
  };

  const onExpandedSectionChange = (section) => {
    dispatch(setExpandedSection(section));
  };

  // Initialize expanded section on mount or when defaultExpandedSection prop changes (prevents flickering)
  useEffect(() => {    
    const currentTabName = activeTab?.name;
    const enteredPending =
      currentTabName === "pending" && previousTabName.current !== "pending";

    if (currentTabName === "pending") {
      // Open prescribed Rx by default when entering pending tab,but allow user to collapse it afterwards.
      if (enteredPending && expandedSection !== null) {
        dispatch(setExpandedSection("prescribedRx"));
      }
      previousTabName.current = currentTabName;
      hasInitializedExpandedSection.current = true;
      previousDefaultExpandedSection.current = defaultExpandedSection;
      return;
    }
    previousTabName.current = currentTabName;
    
    // Don't reset if user explicitly closed the section (expandedSection is null)
    if (expandedSection === null && hasInitializedExpandedSection.current) {
      return;
    }
    
    const defaultExpandedSectionChanged = previousDefaultExpandedSection.current !== defaultExpandedSection;
    const shouldInitialize = (!hasInitializedExpandedSection.current && !expandedSection) || defaultExpandedSectionChanged;
    
    if (shouldInitialize && (defaultExpandedSection || !expandedSection)) {
      const sectionToSet = defaultExpandedSection || (() => {
        if (clinicalServiceName === ClinicalServiceTypes.AllergicRhinitis) {
          const treatment = clinicalServiceObj?.initialAssessment?.initialAssessmentForm?.treatment;
          const treatmentDrugs = treatment ? getTreatmentDrugs(treatment) : [];
          return treatmentDrugs.length > 0 ? "prescribedRx" : "prescription";
        } else {
          return prescribedRxEnabled ? "prescribedRx" : "prescription";
        }
      })();

      dispatch(setExpandedSection(sectionToSet));
      hasInitializedExpandedSection.current = true;
      previousDefaultExpandedSection.current = defaultExpandedSection;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultExpandedSection, expandedSection, clinicalServiceName, prescribedRxEnabled, activeTab, dispatch]);

  return (
    <>
      {showMeds && (
        <div
          className={`flex flex-col h-full justify-between ${isIntervention ? "w-full min-w-0 max-w-[460px]" : "w-[318px]"}`}
        >
          <div className="flex flex-col flex-1 gap-5 pt-2">
            {!isIntervention && (
              <MedicationsHeader
                showMeds={showMeds}
                getFilterMenu={!isAMR || isPreReview ? getFilterMenu : null}
                isIntervention={isIntervention}
                clinicalServiceName={clinicalServiceName}
                onAddMedication={() => setShowAddMedicationDialog(true)}
                showInterectionTooltip={showInterectionTooltip}
                setShowInterectionTooltip={setShowInterectionTooltip}
                suppressAddButton={activeTab?.name === "pending"}
              />
            )}
            <div className="flex flex-col justify-between">
              <div className="flex flex-col">
                {!isAMR && (
                  <StandardMedicationView
                    filteredMedication={filteredMedication}
                    onMedicationClick={handleMedicationListMedicationClick}
                    onMenuAction={handleMedicationListMenuAction}
                    onExpandMedication={handleMedicationListExpandMedication}
                    expandedMedications={selectedMedsForAccordion}
                    hoveredMed={hoveredMed}
                    onMouseEnter={setHoveredMed}
                    onMouseLeave={() => setHoveredMed(null)}
                    menuMedication={menuMedication}
                    onMenuOpen={handleMedicationListMenuOpen}
                    showMenu={showMenu}
                    menuData={menuData}
                    selectedMedication={selectedMedication}
                    isMatchingDrug={isMatchingDrug}
                    medicationDetails={medicationDetails}
                    getNoRecordMessage={getNoRecordMessage}
                    isIntervention={isIntervention}
                    clinicalServiceObj={clinicalServiceObj}
                    clinicalServiceName={clinicalServiceName}
                    expandedSection={expandedSection}
                    onExpandedSectionChange={(section) => {
                      onExpandedSectionChange(section);
                    }}
                    prescribedRxEnabled={prescribedRxEnabled}
                    activeTab={activeTab}
                  />
                )}
                {isAMR && (
                  <>
                    <Tab.Group>
                      <Tab.Panels className="">
                        <Tab.Panel
                          className={classNames(
                            "rounded-xl bg-white",
                            "ring-white ring-opacity-60 ring-offset-2 focus:outline-none focus:ring-2"
                          )}
                        >
                          <div className={`flex flex-row justify-between pb-2`}>
                            <div className="flex flex-row">
                              <div className="flex items-center gap-[6px]">
                                <button
                                  className={`font-semibold text-base text-gray-800 ${
                                    isPreReview && "border-b-[3px] border-teal-300"
                                  }`}
                                  onClick={() => {
                                    setIsPreReview(true);
                                  }}
                                >
                                  Pre-Review
                                </button>
                                <InfoTool id="pre-review" ariaLabel="Pre review info" />
                                <NewToolTip id="pre-review" render={() => <PreReview />} />
                              </div>
                            </div>
                            <div className="flex flex-row">
                              <div className="flex items-center gap-[6px]">
                                <button
                                  className={`font-semibold text-base text-gray-800 ${
                                    !isPreReview && "border-b-[3px] border-teal-300"
                                  }`}
                                  onClick={() => {
                                    setIsPreReview(false);
                                  }}
                                >
                                  Post-Review
                                </button>
                                <InfoTool id="post-review" ariaLabel="Post review info" />
                                <NewToolTip id="post-review" render={() => <PostReview />} />
                              </div>
                            </div>
                          </div>
                          {isPreReview && (
                            <AMRPreReviewView
                              filteredMedication={filteredMedication}
                              reviewedMedicationCards={reviewedMedicationCards}
                              onMedicationClick={
                                handleMedicationListMedicationClick
                              }
                              onMenuAction={handleMedicationListMenuAction}
                              onExpandMedication={
                                handleMedicationListExpandMedication
                              }
                              expandedMedications={selectedMedsForAccordion}
                              hoveredMed={hoveredMed}
                              onMouseEnter={setHoveredMed}
                              onMouseLeave={() => setHoveredMed(null)}
                              menuMedication={menuMedication}
                              onMenuOpen={handleMedicationListMenuOpen}
                              showMenu={showMenu}
                              menuData={menuData}
                              selectedMedication={selectedMedication}
                              isMatchingDrug={isMatchingDrug}
                              medicationDetails={medicationDetails}
                              getNoRecordMessage={getNoRecordMessage}
                              getCardFromDrug={getCardFromDrug}
                              selectMedication={selectMedication}
                              defaultExpandedSection={defaultExpandedSection}
                              medications={medications}
                              clinicalServiceObj={clinicalServiceObj}
                            />
                          )}
                          {!isPreReview && (
                            <AMRPostReviewView
                              reviewedMedicationCards={reviewedMedicationCards}
                              medications={medications}
                              expandedDiscontinued={expandedDiscontinued}
                              toggleDiscontinuedExpansion={
                                toggleDiscontinuedExpansion
                              }
                              selectMedication={selectMedication}
                              getDrugFromCard={getDrugFromCard}
                              AdherenceTypes={AdherenceTypes}
                            />
                          )}
                        </Tab.Panel>
                      </Tab.Panels>
                    </Tab.Group>
                  </>
                )}
              </div>
            </div>
          </div>
          {patient?.preferences === "blisterPack" && (
            // <div className="flex flex-col pb-4">

            <div
              className={`flex gap-10 p-[10px] mb-1 py-3 bg-gray-20 items-center justify-center`}
            >
              <p className="text-lg font-bold text-teal-300">Blister Pack</p>
            </div>
          )}
        </div>
      )}

      {!isIntervention && (
        <div className="mx-2 flex justify-center items-center w-[7px] h-auto bg-gray-100">
          {/* <div className=""></div> */}
          {!showMeds && (
            <button
              className="rounded-full w-5 h-5 bg-teal-600 mb-[100px]  border-teal-600 text-white inline-flex duration-300 items-center justify-center px-1 py-1"
              onClick={() => {
                setShowMeds(true);
              }}
            >
              <ChevronRightIcon className="w-4 h-4 text-white" />
            </button>
          )}
          {showMeds && (
            <button
              className="rounded-full w-5 h-5 bg-teal-600 mb-[100px]  border-teal-600 text-white inline-flex duration-300 items-center justify-center px-1 py-1"
              onClick={() => {
                setShowMeds(false);
              }}
            >
              <ChevronLeftIcon className="w-4 h-4 text-white" />
            </button>
          )}
        </div>
      )}
      <>{showMenu && getMenuContent()}</>
      {/* Drug Induced Medical Condition Models */}
      <MedicationCreate
        key={`medication-form-${medicationFormKey}`}
        create={clickedMedication?.id ? false : true}
        patientId={patientId}
        type="Medication"
        open={showMedicationSlider}
        fullMedication={clickedMedication}
        initialData={latestMedicationData}
        step={1}
        maxSteps={1}
        onClose={(value) => {
          setClickedMedication(null);
          // Normal close - clear data and close slider
          setLatestMedicationData(null);
          setShowMedicationSlider(false);
        }}
        onSave={() => {
          setShowMedicationSlider(false);
          setLatestMedicationData(null);
        }}
        onSaveAndAddAnother={(data) => {
          // Create a new object reference to ensure React detects the change
          const newInitialData = {
            startDate: data.startDate,
            source: data.source,
            communicationType: data.communicationType,
            prescriberName: data.prescriberName,
            applyToAll: data.applyToAll
          };
          // Close slider first
          setShowMedicationSlider(false);
          // Increment key to force remount, set data, then reopen
          // This ensures a fresh form instance with the new initialData
          setTimeout(() => {
            setMedicationFormKey(prev => prev + 1);
            setLatestMedicationData(newInitialData);
            setShowMedicationSlider(true);
          }, 150);
        }}
      />

      {/* AddMedicationDialog */}
      <AddMedicationDialog
        open={showAddMedicationDialog}
        onClose={handleAddMedicationDialogClose}
        onSave={handleAddMedicationDialogSave}
        patientId={patientId}
      />

      <DiscontinueDialog
        open={openDiscontiuePopup}
        drug={discontinueDrug}
        onCross={() => {
          setOpenDiscontiuePopup(false);
          setDiscontinueDrug(null);
        }}
        handleClose={() => {
          setMenuMedication(null);
          setOpenDiscontiuePopup(false);
          setDiscontinueDrug(null);
        }}
        confirmAction={(discontinueData) => {
          updateMedicationStatus(discontinueDrug, "inactive", discontinueData);
          setOpenDiscontiuePopup(false);
          setDiscontinueDrug(null);
        }}
      />
    </>
  );
};

export default Medications;
